import React from 'react';
import { Box } from '@mui/material';

import { CheckIcon } from '@/src/ui';

type LegendPillProps = { children: React.ReactNode };
const LegendPill = ({ children }: LegendPillProps) => (
    <span
        style={{
            background: '#f7f7f7',
            border: '1px solid #e1e1e1',
            borderRadius: 12,
            padding: '2px 8px',
            fontWeight: 600,
            fontSize: 13,
            display: 'inline-block',
            minWidth: 24,
            textAlign: 'center',
        }}
    >
        {children}
    </span>
);

type ClassMatrixLegendProps = {
    dataLoaded: boolean;
    showLegend: boolean;
};

const ClassMatrixLegend: React.FC<ClassMatrixLegendProps> = (props) => {
    const { dataLoaded, showLegend } = props;

    if (!dataLoaded || !showLegend) return null;

    return (
        <Box sx={{ position: 'relative', display: 'inline-block' }}>
            {showLegend && (
                <Box
                    sx={{
                        top: '100%',
                        left: 0,
                        zIndex: 10,
                        mt: 1,
                        border: '1px solid #e5e7eb',
                        borderRadius: 2,
                        p: 1.5,
                        bgcolor: '#fff',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                        fontSize: 14,
                        color: '#555',
                        width: 'fit-content',
                        maxWidth: 700,
                    }}
                    aria-label="Status legend"
                >
                    {/* Statuses */}
                    <Box sx={{ fontWeight: 700, fontSize: 13, color: '#333', mb: 0.75 }}>
                        Statuses
                    </Box>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr',
                            columnGap: 3,
                            rowGap: 1,
                            mb: 1.5,
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LegendPill>INC</LegendPill>
                            <span>Incomplete</span>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LegendPill>HS</LegendPill>
                            <span>Needs Handscore</span>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LegendPill>
                                <CheckIcon color="green" />
                            </LegendPill>
                            <span>Complete</span>
                        </Box>
                    </Box>

                    {/* Question Types */}
                    <Box sx={{ fontWeight: 700, fontSize: 13, color: '#333', mb: 0.75 }}>
                        Question Types
                    </Box>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr 1fr',
                            columnGap: 3,
                            rowGap: 1,
                            mb: 1.25,
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LegendPill>MC</LegendPill>
                            <span>Multiple Choice</span>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LegendPill>OT</LegendPill>
                            <span>Open Text</span>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LegendPill>MS</LegendPill>
                            <span>Multiple Select</span>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LegendPill>MA</LegendPill>
                            <span>Matrix</span>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LegendPill>DD</LegendPill>
                            <span>Drag & Drop</span>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LegendPill>GR</LegendPill>
                            <span>Graphing</span>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            fontWeight: 600,
                            fontSize: 12.5,
                            color: '#333',
                        }}
                    >
                        *Multiple Choice and Multiple Select questions will display the correct
                        choice.
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default ClassMatrixLegend;
